import React, { createContext, useContext, useEffect, useState } from 'react';
import catalog from './product-catalog';

const SUPABASE_URL = (
  process.env.GATSBY_SUPABASE_URL ||
  process.env.SUPABASE_URL ||
  'https://vvowqbxqigppsrdnnnqd.supabase.co'
).replace(/\/$/, '');

const SUPABASE_ANON_KEY =
  process.env.GATSBY_SUPABASE_PUBLISHABLE_KEY ||
  process.env.GATSBY_SUPABASE_ANON_KEY ||
  process.env.SUPABASE_PUBLISHABLE_KEY ||
  process.env.SUPABASE_ANON_KEY ||
  '';

const PricingContext = createContext({ version: 0, ready: false });

/**
 * Loads live product pricing (price, discounts, shipping) from the
 * product_pricing table and installs it into the shared catalog module.
 * `version` bumps once rows load so consumers re-render with live values;
 * until then everything shows the hardcoded catalog fallbacks.
 */
export function PricingProvider({ children }) {
  const [state, setState] = useState({ version: 0, ready: false });

  useEffect(() => {
    if (typeof window === 'undefined' || !SUPABASE_URL || !SUPABASE_ANON_KEY) return undefined;
    let cancelled = false;

    (async () => {
      try {
        const response = await fetch(`${SUPABASE_URL}/rest/v1/product_pricing?select=*`, {
          headers: {
            apikey: SUPABASE_ANON_KEY,
            Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          },
        });
        if (!response.ok) return;
        const rows = await response.json();
        if (cancelled || !Array.isArray(rows) || rows.length === 0) return;
        catalog.setLivePricing(rows);
        setState((prev) => ({ version: prev.version + 1, ready: true }));
      } catch {
        // Offline / blocked — static catalog pricing stays in effect.
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return <PricingContext.Provider value={state}>{children}</PricingContext.Provider>;
}

/** Re-render subscription for live pricing. Safe to call without a provider. */
export function usePricingVersion() {
  return useContext(PricingContext).version;
}
